import { useEffect, useRef } from 'react';
import { ArenaMedia, ma } from './ArenaMedia.jsx';
import { IconHistory, IconSword, IconX } from '../../components/icons.jsx';

const EFFECTS = {
  blood: ['Кровотечение', 'harmful'], heal: ['Исцеление', 'healing'],
  reflect: ['Отражение', 'special'], mirror: ['Зеркало', 'special'],
  armor: ['Защита', 'defense'], critical: ['Критический удар', 'power'],
  critical_missed: ['Крит не сработал', 'muted'], suppressed: ['Модификатор отключён', 'harmful'],
  stun_missed: ['Оглушение не сработало', 'muted'], invulnerable: ['Урон заблокирован', 'defense'],
  invulnerability_missed: ['Неуязвимость не сработала', 'muted'], cry: ['Боевой клич', 'power'],
  scheduled: ['Эффект подготовлен', 'special'],
};

export function ArenaBattleLog({ battle, onClose }) {
  const closeButton = useRef(null);
  useEffect(() => {
    const previous = document.activeElement;
    closeButton.current?.focus();
    return () => previous?.isConnected && previous.focus();
  }, []);
  return <section className="arena-turns" aria-label="История ходов" onKeyDown={event => {
    if (event.key === 'Escape') { event.preventDefault(); event.stopPropagation(); onClose(); }
  }}>
    <header><IconHistory /><div><b>Хроника боя</b><small>{battle.events.length} / 10 ходов</small></div>
      <button ref={closeButton} type="button" onClick={onClose} aria-label="Закрыть историю ходов"><IconX /></button>
    </header>
    {!battle.events.length ? <p className="arena-turns-empty">✦<b>Дуэль только начинается</b><span>Здесь появятся сыгранные карты и эффекты</span></p> :
      <ol>{[...battle.events].reverse().map(item => {
        const side = item.isMe ? battle.me : battle.opponent;
        const card = side.cards.find(candidate => candidate.slot === item.slot && !candidate.hidden)
          || side.cards.find(candidate => candidate.used && !candidate.hidden && candidate.name === item.cardName);
        return <li key={item.turn} className={item.isMe ? 'arena-turn-own' : 'arena-turn-enemy'}>
          <span className="arena-turn-number">{item.turn}</span>
          <div className="arena-turn-art">{card ? <ArenaMedia card={card} /> : <IconSword />}</div>
          <div className="arena-turn-body"><div className="arena-turn-heading"><b>{item.isMe ? 'Вы' : 'Противник'}</b>{item.automatic && <small>Автоход</small>}<strong>−{ma(item.damage)}</strong></div>
            <span className="arena-turn-card">{item.cardName}</span>
            {item.modifier && <span className="arena-turn-modifier">{item.modifier}</span>}
            {!!item.effects?.length && <div className="arena-turn-effects">{item.effects.map((effect, index) => {
              const [label, tone] = EFFECTS[effect.kind] || [effect.modifier || 'Эффект', 'special'];
              return <span key={index} className={`arena-turn-effect-${tone}`}>{label}{effect.amount ? <b>{effect.kind === 'heal' ? '+' : ''}{ma(effect.amount)}</b> : null}</span>;
            })}</div>}
          </div>
        </li>;
      })}</ol>}
  </section>;
}
